import { FC } from "react";
import './SpinnerMini.css';
const SpinnerMini: FC = () => {
  return (
    <div className="spinner__mini" data-testid = "spinner-mini" />
  )
}

export default SpinnerMini;